/**
 * @author Pawan Sadvale
 * @email Pawan.Sadvale@ul.com
 * @create date 2020-02-26 15:07:41
 * @modify date 2020-02-26 15:07:41
 * @desc [description]
 */
import axios from 'axios';

/**
 * update headline put api
 * to update headline content */
export async function updateHeadline(data) {
  let result = '';
  await axios
    .put(`${process.env.VUE_APP_JAVA_API_URL}/dashboard/headlines`, data)
    .then((response) => {
      if (response) result = response;
    })
    .catch((err) => {
      console.log('set headline java api error', err); // eslint-disable-line no-console
    });
  return result;
}
/**
 * headlines delete api
 * to delete headline */
export async function deleteHeadline(formData) {
  let data = '';
  await axios
    .delete(`${process.env.VUE_APP_JAVA_API_URL}/dashboard/headlines`, { data: formData })
    .then(() => {
      data = {
        status: true,
      };
    })
    .catch((err) => {
      data = {
        status: false,
      };
      console.log('remove headline  java api error', err); // eslint-disable-line no-console
    });
  return data;
}
/**
 * getHeadliness get api
 * to headline list */
export async function getHeadlines() {
  let result = [];
  await axios.get(`${process.env.VUE_APP_JAVA_API_URL}/dashboard/headlines`)
    .then((response) => {
      if (response.status === 200) {
        result = response.data;
        console.log('reuslt', result);
      }
    })
    .catch((err) => {
      console.log('get headline java api error', err); // eslint-disable-line no-console
    });
  return result;
}
/**
 * addHeadline post api
 * to add new headline  */
export async function addHeadline(data) {
  let result = '';
  await axios.post(`${process.env.VUE_APP_JAVA_API_URL}/dashboard/headlines`, data)
    .then((response) => {
      if (response) {
        result = response;
      }
    })
    .catch((err) => {
      console.log('add headline java api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * Mfa get api
 * to get the mfa data */
export async function getMultiFactorAuthentication() {
  let result = '';
  await axios.get(`${process.env.VUE_APP_JAVA_API_URL}/mfa`)
    .then((response) => {
      if (response.status === 200) {
        result = response.data;
      }
    })
    .catch((err) => {
      console.log('get mfa java api error', err); // eslint-disable-line no-console
    });
  return result;
}
